interface SiloFormProps {
  delivery: any; //todo: update this when we migrate farmer web as well
  changeDeliverySilo: (siloId: string) => void;
  silos: any[];
  t: any;
}

const SingleDeliverySiloForm: React.FC<SiloFormProps> = (props) => {
  const { delivery, changeDeliverySilo, t, silos } = props;

  if (!delivery.siloId) return null;

  return (
    <div className="w-full max-w-30-0">
      <p className="mb-0-6 text-2-0 md:text-1-4 leading-1-33 font-li">
        {t('checkout.choose_silo')}
      </p>
      <select
        className="w-full rounded-8-0 p-1-0 border-secondary-grey text-body1 leading-1-25 border bg-white"
        data-testid={`delivery-silo-${delivery.id}`}
        value={delivery.siloId || 1}
        onChange={(e) => changeDeliverySilo(e.target.value)}
      >
        {silos.map((silo) => (
          <option key={silo.id} value={silo.id}>
            {silo.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default SingleDeliverySiloForm;
